import colours from "./constants/colours";

export const theme = {
  token: {
    colorPrimary: colours.primary,
    colorPrimaryHover: colours.primaryLight,
    colorBgContainer: colours.background,
    colorWarning: colours.accent,
    fontFamily: "Poppins, sans-serif",
    borderRadius: 4,
    controlHeight: 40,
  },
  components: {
    Layout: {
      headerBg: colours.white,
      bodyBg: colours.background,
      siderBg: colours.primary,
    },
    Button: {
      fontFamily: "Lato, sans-serif",
      colorPrimary: colours.primary,
      colorPrimaryHover: colours.primaryLight,
    },
    Tabs: {
      titleFontSize: 12,
      itemColor: colours.primary,
      itemSelectedColor: colours.primary,
      itemHoverColor: colours.primaryLight,
      inkBarColor: colours.primary,
    },
    Typography: {
      fontFamily: "Poppins, sans-serif",
    },
    Menu: {
      darkItemBg: colours.primary,
      darkItemHoverBg: colours.primaryLight,
      darkItemSelectedBg: colours.primaryLight,
    },
    Card: {
      extraColor: colours.primary,
      colorTextHeading: colours.primary,
      headerFontSize: 14,
      paddingLG: 16,
      colorBgContainer: colours.white,
      borderRadiusLG: 8,
      boxShadowTertiary: "0 1px 4px rgba(0,0,0,0.08)",
    },
    Modal: {
      borderRadiusLG: 16,
      titleFontSize: 18,
      paddingContentHorizontalLG: 24,
    },
  },
};

export const heroCardTheme = {
  token: {
    colorPrimary: colours.primary,
    colorTextHeading: colours.white,
    colorText: colours.white,
  },
  components: {
    Card: {
      extraColor: colours.primary,
       paddingLG: 24,
    },
  },
};

export default theme;
